import { useEffect, useState } from 'react';
import { ADMIN_GATEWAY_URL, getAdminSession, openAdminSignIn, openAdminSignOut, type AdminSession } from '../lib/adminGateway';

export function AdminAccessSettings(): JSX.Element {
  const [session, setSession] = useState<AdminSession | null>(null);
  const [state, setState] = useState<'idle' | 'loading' | 'unavailable'>('idle');

  const refresh = async (): Promise<void> => {
    if (!ADMIN_GATEWAY_URL) return;
    setState('loading');
    try {
      setSession(await getAdminSession());
      setState('idle');
    } catch {
      setSession(null);
      setState('unavailable');
    }
  };

  useEffect(() => {
    void refresh();
    const onFocus = (): void => { void refresh(); };
    window.addEventListener('focus', onFocus);
    return () => window.removeEventListener('focus', onFocus);
  }, []);

  return (
    <section className="card stack settings-grouped" aria-labelledby="administrator-settings-title">
      <h2 id="administrator-settings-title" className="mt-0">Administrator</h2>
      <p className="page-lead mt-0">Access privileged read-only catalogue tools.</p>
      {!ADMIN_GATEWAY_URL ? <p className="hint">Administrator access is not configured for this environment.</p> : null}
      {session?.authenticated ? (
        <>
          <p className="hint">Signed in as <strong>{session.email}</strong><br />Access: Read Only</p>
          <div className="row">
            <a className="btn btn-primary" href="/admin">Open Admin Tools</a>
            <button type="button" className="btn btn-secondary" onClick={openAdminSignOut}>Sign Out</button>
          </div>
        </>
      ) : (
        <button type="button" className="btn btn-primary" disabled={!ADMIN_GATEWAY_URL || state === 'loading'} onClick={openAdminSignIn}>
          {state === 'loading' ? 'Checking…' : 'Sign In'}
        </button>
      )}
      {state === 'unavailable' ? <p className="hint" role="status">Administrator gateway is unavailable or you are signed out.</p> : null}
    </section>
  );
}
